import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import type { CreateWebhookEndpointData, UpdateWebhookEndpointData } from "../../types/webhook-endpoint";
import webhookEndpointService from "../services/webhook-endpoint-service";

export const webhookEndpointsQueryOptions = (params: Record<string, unknown> = {}) =>
	queryOptions({
		queryKey: ["webhook-endpoints", params],
		queryFn: () => webhookEndpointService.list(params),
	});

export const useWebhookEndpointCreateMutation = () =>
	useMutation({
		mutationFn: (data: CreateWebhookEndpointData) => webhookEndpointService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["webhook-endpoints"] });
		},
	});

export const useWebhookEndpointUpdateMutation = (id: string) =>
	useMutation({
		mutationFn: (data: UpdateWebhookEndpointData) => webhookEndpointService.updateById(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["webhook-endpoints"] });
		},
	});

export const useWebhookEndpointDeleteMutation = () =>
	useMutation({
		mutationFn: (id: string) => webhookEndpointService.deleteById(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["webhook-endpoints"] });
		},
	});
